/**
 * render-weekly-viewing-levels-csv
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2017 Mediatel Limited.
 */

"use strict";

export default function renderWeeklyViewingLevelsCSV(data) {
    if (data.length < 1) {
        return "No data for this combination of periods and players";
    }

    const rows = data.categories.map((category, index) => {
        return `"${category}",` +
            data.series.map((player) => {
                return `"${player.data[index]}"`;
            }).join(',');
    }).join("\n");

    return `"Period",` +
        data.series.map((player) => {
            return `"${player.name}"`;
        }).join(',') +
        `\r\n${rows}`;
};